import { useMemo } from "react";
import { useApp } from "@/app/AppContext";
import { useActiveColumns, useSelectedView, useVisibilityFilter } from "@/app/selectors";
import { buildMatrix, getLegendCodes, type MatrixRow } from "@/domain/matrix";
import type { ColumnDefinition, ColumnLayout, View } from "@/domain/types";

export interface MatrixModel {
  view: View;
  layoutId: string;
  layout: ColumnLayout | null;
  columns: ColumnDefinition[];
  rows: MatrixRow[];
  legendCodes: string[];
}

export function useMatrixModel(): MatrixModel {
  const { data } = useApp();
  const view = useSelectedView();
  const { layoutId, layout, columns } = useActiveColumns();
  const isVisible = useVisibilityFilter({ includeSearch: true });

  return useMemo(() => {
    const rows = buildMatrix({
      items: data.dataset.items,
      columns,
      layoutId,
      view,
      arenas: data.settings.arenas,
      dataFile: data.dataFile,
      isVisible,
    });
    return { view, layoutId, layout, columns, rows, legendCodes: getLegendCodes(rows, view) };
  }, [
    data.dataset.items,
    data.settings.arenas,
    data.dataFile,
    columns,
    layoutId,
    layout,
    view,
    isVisible,
  ]);
}
